import React from 'react'
import mainLogo from './assets/logo.svg'
import mobLogo from './assets/logo-mob.svg';

const Loading = () => {
    return (
        <>
            <div className='pageloading'>
                <div>
                    <div className="navbar-logo d-lg-none">
                        <img className='img-fluid' src={mobLogo} width={44} height={51} loading="eager" alt='Logo for Kancaroo Trusted Car Carriers, featuring a sleek design with a car silhouette and the company name.' />
                    </div>
                    <div className="navbar-logo d-none d-lg-block">
                        <img
                            src={mainLogo} alt="Represents our brand's identity and commitment to quality." width={166} height={166} loading="eager" />
                    </div>
                    <p className='mainHeading mt-4'>Loading....</p>
                </div>
            </div>
        </>
    )
}

export default Loading